import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <>
      <h1>Not found</h1>
      <p>
        There's no such page. <Link to="/">Back to the overview</Link>
      </p>
    </>
  );
}
